import React from "react"
import PropTypes from "prop-types"
// import bell from '../../assets/images/header/bell.png'
import axios from 'axios';
class Touring_group_list extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      touring_group_join: this.props.touring_group_join,
      parent_touring_group_ids: this.props.parent_touring_group_ids,
      child_touring_group_ids: this.props.child_touring_group_ids,
    };
  }

  handleSubmit = async (touring_group_id, method) => {
    const url = method === "delete" ? `/user_touring_groups/${touring_group_id}` : '/user_touring_groups';
    let csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
    let currentPath = window.location.pathname;
    try {
      const response = await axios({
        method: method,
        url: url,
        data: {
          touring_group_id: touring_group_id,
          from_path: currentPath
        },
        headers: {
          'X-CSRF-Token': csrfToken
        }
      });

      if (method === 'delete' && response.status === 204) {
        const updatedTouringGroupJoin = this.state.touring_group_join.filter(group => group.id !== touring_group_id);
        this.setState({ touring_group_join: updatedTouringGroupJoin });

        const updatedChildTouringGroupIds = this.state.child_touring_group_ids.filter(id => id !== touring_group_id);
        this.setState({ child_touring_group_ids: updatedChildTouringGroupIds });
      } else if (method === 'post' && response.status === 200) {
        const updatedTouringGroupJoin = this.state.touring_group_join.filter(group => group.id !== touring_group_id);
        this.setState({ touring_group_join: updatedTouringGroupJoin });

        const updatedChildTouringGroupIds = this.state.child_touring_group_ids.filter(id => id !== touring_group_id);
        this.setState({ child_touring_group_ids: updatedChildTouringGroupIds });
      }
      // }

      // Handle the response from the server
    } catch (error) {
      // Handle the error
    }
  }

  cutStringByByte = (str, maxByte) => {
    let b = 0;
    let limitLen = 0;
    for (let i = 0; i < str.length; i++) {
      let c = str.charCodeAt(i);  // letを追加
      b += c < 128 ? 1 : 2;
      if (b > maxByte) break;
      limitLen = i + 1;
    }
    return str.substring(0, limitLen);
  };

  formatDate = (dateString) => {
    const date = new Date(dateString);
    const month = date.getMonth() + 1; // getMonthは0から始まるので1を加えます
    const day = date.getDate();
    const week = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][date.getDay()]; // getDayは0(Sunday)-6(Saturday)の値を返します
    return `${month}/${day}(${week})`;
  }

  render () {
    return (
      <React.Fragment>
        <section id="touring-group">
          <div className="container3">
            <div className="touring-group-head">
              <h2>
                {this.props.touring_group_list_title}
              </h2>
            </div>
            {this.state.touring_group_join && this.state.touring_group_join.length > 0 ? (
              this.state.touring_group_join.map((touring_group) => {


                const title = touring_group.touring_title;
                let max_bytesize;
                if (/^[^\x01-\x7E\xA1-\xDF]+$/.test(title)) {
                  max_bytesize = 24;
                } else {
                  max_bytesize = 22;
                }
                const limitedTitle = this.cutStringByByte(title, max_bytesize);
                
                return (
                  <div className="touring-title index" key={touring_group.id}>
                    <a href={`/touring_groups/${touring_group.id}`} className="touring-title-overlay" data-turbolinks={false}></a>
                    <p className="index">
                      {limitedTitle}
                    </p>
                    <p className="touring-title-date">
                      {this.formatDate(touring_group.touring_date)}
                    </p>


                    {this.state.parent_touring_group_ids.includes(touring_group.id) && (
                      <div className="touring-title-button yellow">親</div>
                    )}
                    {this.state.child_touring_group_ids.includes(touring_group.id) && (
                      <button onClick={() => this.handleSubmit(touring_group.id, 'delete')} className="touring-title-button blue">参加</button>
                    )}
                    {!this.state.child_touring_group_ids.includes(touring_group.id) && !this.state.parent_touring_group_ids.includes(touring_group.id) && (
                      <button onClick={() => this.handleSubmit(touring_group.id, 'post')} className="touring-title-button red">不参加</button>
                    )}
                  </div>
                );
              })
              ) : (
              <div>
                {this.props.no_touring_group_reply}
              </div>
            )}
          </div>
        </section>
      </React.Fragment>
    );
  }
  
}

Touring_group_list.propTypes = {
  touring_group_list_title: PropTypes.string,
  touring_group_join: PropTypes.array,
  parent_touring_group_ids: PropTypes.array,
  child_touring_group_ids: PropTypes.array,
  // touring_group_path: PropTypes.func,
  // user_touring_group_path: PropTypes.func,
  // user_touring_groups_path: PropTypes.func,
};
export default Touring_group_list